module.exports = __webpack_public_path__ + "img/checkout.6812c5bd.png";